import { SubmitHandler } from 'redux-form';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { ButtonProps, Dialog, DialogProps, Size } from '@optimus-web/core';

export interface EditDialogFormProps extends Partial<DialogProps> {
    active: boolean;
    closeDialog: () => void;
    handleSubmit: SubmitHandler;
    loading: boolean;
    primaryButtonTextKey?: Mews.TextKey;
    primaryButtonVariant?: ButtonProps['variant'];
    primaryButtonDataTestId?: DataTestId;
    primaryButtonForm?: string;
    secondaryButtonTextKey?: Mews.TextKey;
    secondaryButtonVariant?: ButtonProps['variant'];
    title: React.ReactNode;
    buttonsSize?: Size;
    floatingPanel?: boolean;
}

const EditDialogForm: React.FC<EditDialogFormProps> = ({
    active,
    buttonsSize,
    closeDialog,
    children,
    handleSubmit,
    loading,
    primaryButtonTextKey = TextKey.Save,
    primaryButtonVariant = 'primary',
    primaryButtonDataTestId = '',
    primaryButtonForm,
    secondaryButtonTextKey = TextKey.GoBack,
    secondaryButtonVariant = 'ghost',
    title,
    floatingPanel,
    ...props
}) => {
    const OverlayComponent = floatingPanel ? FloatingPanel : Dialog;

    return (
        <OverlayComponent
            actions={[
                {
                    children: <LocalizedText textKey={secondaryButtonTextKey} />,
                    onClick: closeDialog,
                    variant: secondaryButtonVariant,
                    size: buttonsSize,
                    type: 'button',
                },
                {
                    children: <LocalizedText textKey={primaryButtonTextKey} />,
                    onClick: handleSubmit,
                    variant: primaryButtonVariant,
                    key: primaryButtonDataTestId,
                    size: buttonsSize,
                    type: 'submit',
                    ...(primaryButtonForm ? { form: primaryButtonForm } : {}),
                },
            ]}
            active={active}
            loading={loading}
            title={title}
            onClose={closeDialog}
            {...props}
        >
            {children}
        </OverlayComponent>
    );
};

export default EditDialogForm;
